import create from 'zustand'
import { CallAppointmentMonitoring } from '../video-call-types'

type CallMonitoringStore = {
  call: CallAppointmentMonitoring
  appointmentId: string | number
  roomId?: string
  mode?: 'scheduled' | 'immediate'
}

export const useCallMonitoringStore = create<CallMonitoringStore>(() => ({
  call: null,
  appointmentId: null,
  roomId: null,
}))
